module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/SO-05bfb06f8a4fbe86636ce80375c6cb12.png";